import { parseAsString, parseAsStringLiteral, useQueryStates } from "nuqs";
import { RescheduleItemTypeSchema, AbsenceCategorySchema } from "@myapp/contract";
import {
  INITIAL_RESCHEDULE_FILTERS,
  RescheduleFiltersForm,
} from "./rescheduleFilters.types";

const SORT_FIELDS = new Set<RescheduleFiltersForm["sortField"]>([
  "scheduledDate",
  "type",
  "technicianName",
]);

const SORT_DIRECTIONS = new Set<RescheduleFiltersForm["sortDirection"]>([
  "ASC",
  "DESC",
]);

export const useRescheduleFiltersParams = () =>
  useQueryStates(
    {
      type: parseAsStringLiteral([...RescheduleItemTypeSchema.options, ""] as const),
      title: parseAsString.withDefault(INITIAL_RESCHEDULE_FILTERS.title),
      technicianName: parseAsString.withDefault(INITIAL_RESCHEDULE_FILTERS.technicianName),
      reason: parseAsStringLiteral([...AbsenceCategorySchema.options, ""] as const),
      dateFrom: parseAsString.withDefault(INITIAL_RESCHEDULE_FILTERS.dateFrom),
      dateTo: parseAsString.withDefault(INITIAL_RESCHEDULE_FILTERS.dateTo),
      sortField: parseAsString.withDefault(INITIAL_RESCHEDULE_FILTERS.sortField),
      sortDirection: parseAsString.withDefault(INITIAL_RESCHEDULE_FILTERS.sortDirection),
    },
    { clearOnDefault: true },
  );

export type RescheduleFiltersParams = ReturnType<
  typeof useRescheduleFiltersParams
>[0];

export const toRescheduleFiltersForm = (
  params: RescheduleFiltersParams,
): RescheduleFiltersForm => ({
  type: (params.type ?? "") as RescheduleFiltersForm["type"],
  title: params.title,
  technicianName: params.technicianName,
  reason: (params.reason ?? "") as RescheduleFiltersForm["reason"],
  dateFrom: params.dateFrom,
  dateTo: params.dateTo,
  sortField: SORT_FIELDS.has(params.sortField as RescheduleFiltersForm["sortField"])
    ? (params.sortField as RescheduleFiltersForm["sortField"])
    : INITIAL_RESCHEDULE_FILTERS.sortField,
  sortDirection: SORT_DIRECTIONS.has(
    params.sortDirection as RescheduleFiltersForm["sortDirection"],
  )
    ? (params.sortDirection as RescheduleFiltersForm["sortDirection"])
    : INITIAL_RESCHEDULE_FILTERS.sortDirection,
});
